import TimePicker from '@/components/Timepicker/TimePicker2.example';

export default TimePicker;
